import mfunsPlayer from './player';
import '../css/index.scss';
console.log('\n'.concat(' %c mfunsPlayer v', MFUNSPLAYER_VERSION, ' ').concat(GIT_HASH, '%c https://github.com/Mfuns-cn ', '\n', '\n'), 'color: #fff; background: #7b7ff7; padding:5px 0;', 'background: #f5f5f5; padding:5px 0;');
export default mfunsPlayer;